import { PatientData } from '@ispm-shared/modules/patient';

export interface PatientDataState {
  patient: PatientData | null;
  error: string;
}

export const initialState: PatientDataState = {
  patient: null,
  error: null
};
